import useNextRouterEvents from './useNextRouterEvents'

export default useNextRouterEvents
